import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from "@mui/material";

interface DialogComponentProps {
    idUser: string
    emailUser: string
    action: string
    permanent: boolean
    onClickNo: () => void
    onClickYes: () => void
    onClose: () => void
    open: boolean
}
export default function DialogComponent({ open, emailUser, permanent, onClickNo, action, onClose, onClickYes }: DialogComponentProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography color="black">
                        Tem certeza que deseja {action} {emailUser}?
                    </Typography>
                    {permanent && <Typography color="red">
                        Essa operação não poderá ser desfeita
                    </Typography>}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClickNo}
                    color="primary"
                >
                    NÃO
                </Button>
                <Button
                    onClick={onClickYes}
                >
                    SIM
                </Button>
            </DialogActions>
        </Dialog>
    )
}
